import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SupportedLang } from '../config/localized-paths';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {

  constructor(
    private readonly translate: TranslateService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    // The lang value is always valid here: the router only calls this guard
    // for the explicit 'en' and 'es' top-level routes, never for arbitrary
    // path segments, so no fallback redirect logic is needed.
    const lang = route.url[0].path as SupportedLang;
    return this.translate.use(lang).pipe(
      map(() => true as const),
      catchError(() => of(true as const))
    );
  }
}
